import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum IntentInstallErrorCode {
  IntentInstallIsAlreadyRunning = 'IntentInstallIsAlreadyRunning',
  NoInstallationStrategyProvided = 'NoInstallationStrategyProvided',
  IntentInstallFailed = 'IntentInstallFailed',
  AutoPopulationFailed = 'AutoPopulationFailed',
  UnknownHost = 'UnknownHost',
  NoHostDetected = 'NoHostDetected',
  FailedToLoadPanelComponent = 'FailedToLoadPanelComponent',
  UnifiedInstallationError = 'UnifiedInstallationError',
  PanelComponentNotFound = 'PanelComponentNotFound',
}

class IntentInstallError extends BaseError<IntentInstallErrorCode> {
  state: Partial<{
    applicationsToInstall: string;
    intentApp: string;
    appDefinitionId: string;
    isSilent: string;
    host: string;
    panelName: string;
  }> = {};

  constructor(message: string, code: IntentInstallErrorCode) {
    super(message, code, 'Editor Platform Intent Install Error');
  }

  withApplicationsToInstall(applicationsToInstall: string[]) {
    this.state = {
      ...this.state,
      applicationsToInstall: applicationsToInstall.join(','),
    };
    return this;
  }

  withIntentApp(intentApp?: string) {
    if (!intentApp) {
      return this;
    }

    this.state = {
      ...this.state,
      intentApp,
    };
    return this;
  }

  withAppDefinitionId(appDefinitionId: string) {
    this.state = {
      ...this.state,
      appDefinitionId,
    };
    return this;
  }

  withIsSilent(isSilent: boolean = false) {
    this.state = {
      ...this.state,
      isSilent: isSilent.toString(),
    };
    return this;
  }

  withHost(host: string) {
    this.state = {
      ...this.state,
      host,
    };
    return this;
  }

  withPanelName(panelName: string) {
    this.state = {
      ...this.state,
      panelName,
    };
    return this;
  }
}

export const createIntentInstallError = createErrorBuilder<
  IntentInstallErrorCode,
  IntentInstallError
>(IntentInstallError);
